class SectionSuccessStoriesList implements ng.IComponentController {
}

angular.module('animatronApp.sectionSuccessStoriesList', []).component('sectionSuccessStoriesList', {
    controller: SectionSuccessStoriesList,
    templateUrl: require('landing-template/components/sections/section-success-stories-list.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionSuccessStoriesList.ts